<template>
  <div class="checkInventoryModel" ref="checkInventoryModel" :class="{ 'default-modal': !isStandardTable, 'standard-table': isStandardTable }">
    <div class="tag-wrap">
      <div class="tag pt">{{t('渠道层')}}</div>
      <div class="tag px">{{t('配销层')}}</div>
      <div class="tag jh">{{t('聚合层')}}</div>
      <div class="tag lj">{{t('逻辑层')}}</div>
      <div class="tag st">{{t('物理层')}} <Icon type="ios-flag" /></div>
    </div>
   
    <div id="wrapper">
      <div class="panel" v-for="(list, idx) in getList" :key="list.ecode">
        <div class="line-wrap">
          <Icon type="md-pin" v-if="isCurIndex == idx && list.length" />
          <div
            v-for="(item, index) in list"
            :key="index"
            :id="item.source" class="state-item"
            :class="{ disabled: item.isactive == 'N' && idx != 1}"
            @click="handleExpand(item, idx)"
          >
            {{ item.ename }}
            <div class="badge" v-if="Object.keys(noExpandLJC).includes(item.source)">
              <Badge :count="noExpandLJC[item.source]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { newInstance } from '@jsplumb/browser-ui';
// import { BezierConnector } from '@jsplumb/connector-bezier';

export default {
  props: {
    idArray: {
      type: Array,
      defalut: () => [],
    },
  },
  data() {
    return {
      tableName: '',
      instance: '',
      nodeResult: [],
      nodeResultCopy: [],
      isCurIndex: null,
      noExpandLJC: {}
    };
  },
  computed: {
    getList() {
      let result = [];
      this.nodeResult.forEach(it => {
        let arr = it.reduce((pre, i) => {
          if (!pre.map((i) => i.id).includes(i.id)) {
            return pre.concat(i);
          } else {
            return pre;
          }
        }, []);
        result.push(arr)
      })
      return result;
    },
    isStandardTable() {
      return this.$route.params.tableName == 'INVENTORY_MODEL_QUERY'
    }
  },
  async mounted() {
    this.tableName = this.$route.params.tableName
    let { newInstance } = await import('@jsplumb/browser-ui');
    this.instance = newInstance({
      container: document.getElementById('wrapper'),
    });
    if (this.tableName == 'INVENTORY_MODEL_QUERY') {
      setTimeout(() => {
        this.refreshContainer()
        document.querySelector('.ListsForm-button button:first-child').addEventListener('click',(e) =>{
          localStorage.removeItem('INVENTORY_MODEL_QUERY_mounted_count')
        }, false);
      }, 500)
      document.querySelector('.NaVertical-icons .iconfont').addEventListener('click',(e) =>{
        this.resize()
      }, false);
      let result = localStorage.getItem(`${this.tableName}_modal_data`)
      if (result) {
        this.nodeResult = JSON.parse(result)
        this.nodeResultCopy = JSON.parse(result)
        this.instance.deleteEveryConnection() // 删除所有连线
        setTimeout(() => {
          this.resize()
          this.draw()
        }, 500)
      }
    }
    $(window).resize(() => { 
      this.resize()
    });
    if (['CP_C_SHOP', 'SG_C_SHARE_STORE'].includes(this.tableName)) {
      this.init()
    }
    this.$nextTick(() => {
      // 解决遮挡搜索表单问题
      $('.checkInventoryModel.standard-table').css('position', 'absolute').css('top', '145px')
    })
  },
  methods: {
    async init(action) {
      const { tableName } = this.$route.params
      if (['SG_C_SHARE_STORE', 'CP_C_SHOP'].includes(tableName) && this.idArray == undefined) return
      let params = {
        modelLevel0: '',
        modelLevel1: '',
        modelLevel2: '',
        modelLevel3: '',
        modelLevel4: ''
      }
      let allEmpty = true
      let handler = async () => {
        switch (tableName) {
          case 'SG_C_SHARE_STORE': // 逻辑仓档案
            this.isCurIndex = 2
            params.modelLevel2 = this.idArray[0]
            break;
          case 'CP_C_SHOP': // 平台店铺档案
            this.isCurIndex = 0
            params.modelLevel4 = this.idArray[0]
            break;
          case 'INVENTORY_MODEL_QUERY': // 库存模型查询
            if (!localStorage.getItem('INVENTORY_MODEL_QUERY_mounted_count')) {
              localStorage.setItem('INVENTORY_MODEL_QUERY_mounted_count', 1)
              await this.$parent.$parent.$children[3].getFormData().then(res => {
                console.log(res)
                res.CP_C_PHY_WAREHOUSE_ID && (params.modelLevel0 = res.CP_C_PHY_WAREHOUSE_ID[0])
                res.CP_C_STORE_ID && (params.modelLevel1 = res.CP_C_STORE_ID[0])
                res.SG_C_SHARE_STORE_ID && (params.modelLevel2 = res.SG_C_SHARE_STORE_ID[0])
                res.SG_C_SA_STORE_ID && (params.modelLevel3 = res.SG_C_SA_STORE_ID[0])
                res.CP_C_SHOP_ID && (params.modelLevel4 = res.CP_C_SHOP_ID[0])
                allEmpty = Object.values(params).every(i => i == '')
              })
            }
            break;
          default:
            break;
        }
      }

      if (tableName == 'INVENTORY_MODEL_QUERY') {
        if (action == 'clear') return
        if (action == 'search') await handler()
        if (allEmpty && action != 'reset') return $fcError(t('请至少选择一个查询条件'))
      } else {
        handler()
      }
      this.service.inventoryCenter.inventoryModelQuery(params).then(res => {
        if (res.data.code == 0) {
          let stores = []
          const result = []
          const levelPrefix = ['ptdp', 'pxc', 'jxc', 'ljc', 'stc']
          for (let i in res.data.data) {
            stores.push(res.data.data[i])
          }
          stores.reverse().map((i, index) => {
            let list = []
            i.forEach(it => {
              let targetPrefix = index == 0 ? levelPrefix[index] : levelPrefix[index - 1]
              const sourcePrefix =  `${levelPrefix[index]}`
              if (it.prevNodeIds.length) {
                it.prevNodeIds.forEach(ii => {
                  // 一个配销仓有多个策略，每个策略又对应不同得店铺
                  if (typeof ii == 'object') {
                    list.push({ 
                      ...it,
                      isactive: ii.isactive,
                      source: `${sourcePrefix}-${it.id}`,
                      target: `${targetPrefix}-${ii.id}`
                    })
                  } else {
                    list.push({ ...it, source: `${sourcePrefix}-${it.id}`, target: `${targetPrefix}-${ii}` })
                  }
                })
              } else {
                list.push({ ...it, source: `${sourcePrefix}-${it.id}`, target: '' })
              }
            })
            result.push(list)
          })
          this.nodeResult = result
          this.nodeResultCopy = result
          tableName == 'INVENTORY_MODEL_QUERY' && localStorage.setItem(`${tableName}_modal_data`, JSON.stringify(this.nodeResult))
          this.instance.deleteEveryConnection() // 删除所有连线
          setTimeout(() => {
            this.resize()
            this.draw()
          }, 500)
        }
      })
    },
    // 聚合仓- 展开收起选中节点的所有下两层：逻辑仓、实体仓
    handleExpand: _.throttle(function(node, levelIndex) {
      if (levelIndex != 2) return
      this.instance.deleteEveryConnection() // 删除所有连线
      if (Object.keys(this.noExpandLJC).includes(node.source)) {
        delete this.noExpandLJC[node.source]
      } else {
        this.noExpandLJC[node.source] = 0
      }
      this.nodeResult = _.cloneDeep(this.nodeResultCopy)
      Object.keys(this.noExpandLJC).forEach(id => {
        let ljc = this.nodeResultCopy[3].filter(i => i.target == id).map(i => i.source)
        let newLJC = this.nodeResult[3].filter(i => i.target != id)
        let newSTC = this.nodeResult[4].filter(i => !ljc.includes(i.target))
        this.noExpandLJC[id] = Number(ljc.length) + Number(this.nodeResult[4].length - newSTC.length) // 记录收起后的总个数
        this.nodeResult = [...this.nodeResult.slice(0,3), newLJC, newSTC]
      })
      setTimeout(() => {
        this.resize()
        this.draw()
      }, 100)
    }, 500, { 'trailing': false }),
    resize() {
      if (this.tableName == 'INVENTORY_MODEL_QUERY') {
        document.querySelector('#wrapper').scrollTo(0, 0)
        setTimeout(() => { 
          this.refreshContainer() 
        }, 100)
      }
      setTimeout(() => {
        this.instance.repaintEverything()
      }, 600)
    },
    refreshContainer() {
      this.$nextTick(() => {
        $('#wrapper').css('height', 0)
        $('.checkInventoryModel').parent().parent().attr('style', 'order: 3 !important')
        $('.standardTable').css('display', 'none')
        setTimeout(() => {
          let clientHeight = document.body.clientHeight
          let offsetTop = $('.checkInventoryModel').offset().top
          let tagHeight = $('.tag-wrap').height()
          let margin = 12
          let rootWidth = $('.StandardTableListRootDiv').width()
          $('#wrapper').css('height', clientHeight - offsetTop)
          $('#wrapper').css('width', rootWidth - margin * 2)
          $('#wrapper').css('overflow-y', 'auto')
          // $('.tag-wrap').css('width', rootWidth - margin * 2)
        }, 100)
      })
    },
    async draw() {
      let { BezierConnector } = await import('@jsplumb/connector-bezier');
      const defaultOptions = (isActive) => {
        return {
          cssClass: 'line-class', // 边线设置class
          anchor: ['Top', 'Bottom'],
          // anchor: 'AutoDefault',
          endpoint: 'Blank', // 端点类形-空白
          // connector: 'Straight', // 直线
          connector: { type: BezierConnector.type, options: { curviness: 23 }}, // 贝塞尔曲线
          overlays: [{ type: 'Arrow', options: { width: 10, length: 8, location: 1 } }],
          paintStyle: { stroke: isActive == 'Y' ? '#17233d' : '#909399', strokeWidth: 1 }, // 线条填充
          hoverPaintStyle: { stroke: isActive == 'Y' ? '#17233d' : '#909399', strokeWidth: 2 }, // 线条移入时的填充
        }
      };
      
      this.nodeResult.forEach((i) => {
        let r = i.filter(i => i.target != '')
        r.forEach(ii => {
          this.instance.connect({
            ...defaultOptions(ii.isactive),
            source: document.getElementById(ii.source),
            target: document.getElementById(ii.target),
          });
        })
      });
    },
  },
};
</script>

<style lang="less" scoped>
.checkInventoryModel {
  margin: 0 12px;
  width: 80vw;
}
#wrapper {
  position: relative;
  background: #fff;
  height: calc(100vh - 140px);
  padding: 0 12px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.panel {
  .line-wrap {
    position: relative;
    display: inline-flex;
    margin: 30px 0;
    @keyframes myfirst
    {
      from { color: #ff00002e; margin-top: -7px; }
      to { color: red; margin-top: 3px; }
    }
    .iconmd-pin {
      position: relative;
      color: red;
      font-size: 24px;
      margin-right: -3px;
      margin-top: 3px;
      animation: myfirst 2s;
      animation-iteration-count: infinite;
    }
  }
  text-align: center;
}
.panel:nth-child(1) .line-wrap div {
  background: #e4c0ef;
  border: 1px solid #b347d2;
}
.panel:nth-child(2) .line-wrap div {
  background: #c3e5bd;
  border: 1px solid #50b843;
}
.panel:nth-child(3) .line-wrap div {
  background: #ffcabc;
  border: 1px solid #ff4c26;
}
.panel:nth-child(4) .line-wrap div {
  background: #e2f5ff;
  border: 1px solid #2d99d7;
}
.panel:nth-child(5) .line-wrap {
  margin-bottom: 0;
  div {
    background: #f4cc87;
    border: 1px solid #eda938;
  }
}

.state-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 120px;
  min-width: 80px;
  // min-height: 30px;
  // max-height: 40px;
  min-height: 32px;
  padding: 5px;
  color: black;
  background: #f6f6f6;
  border: 2px solid rgba(0, 0, 0, 0.05);
  text-align: center;
  line-height: 18px;
  border-radius: 4px;
  // margin-right: 25px;
  margin-right: 50px;
  &.disabled {
    filter: brightness(0.6);
  }
  .badge {
    position: absolute;
    top: 25px;
    z-index: 200;
    border: none !important;
    border-radius: 10px;
    .ark-badge-count {
      background: #dcdcdf;
    }
  }
}
.ellipsis {
  width: 50px !important;
  align-items: stretch;
  font-size: 20px;
}


.default-modal {
  .tag-wrap {
    display: flex;
    justify-content: flex-end;
    height: 18px;
    background: #fff;
    // padding-top: 40px;
    .tag {
      display: flex;
      align-items: center;
      margin-right: 35px;
    }
  }
  #wrapper {
    margin-top: 10px;
  }
}

.standard-table {
  position: relative;
  .tag-wrap {
    position: absolute;
    width: 100px;
    height: 100px;
    background: #fff;
    top: 10px;
    .tag {
      position: relative;
      left: 35px;
      z-index: 100;
      margin-bottom: 2px;
    }
  }
  .panel:nth-child(1) .line-wrap {
    margin-top: 0;
  }
}
.tag-wrap {
  // display: flex;
  // justify-content: flex-end;
  // height: 18px;
  /* background: #fff;
  height: 0;
  position: relative;
  top: 10px; */
  // padding-top: 40px;
  .tag {
    // display: flex;
    // align-items: center;
    // margin-right: 35px;
    position: relative;
    /* left: 35px;
    z-index: 100;
    margin-bottom: 5px; */
    .before {
      content: '';
      border-radius: 3px;
      position: absolute;
      left: -20px;
    }
    &.st::before {
      .before();
      border: 8px solid #eda938;
    }
    &.lj::before {
      .before();
      border: 8px solid #2d99d7;
    }
    &.jh::before {
      .before();
      border: 8px solid #ff4c26;
    }
    &.px::before {
      .before();
      border: 8px solid #50b843;
    }
    &.pt::before {
      .before();
      border: 8px solid #b347d2;
    }
  }
}
</style>
